import { render } from "./EditorBindModal.vue?vue&type=template&id=55c78642&scoped=true"
import script from "./EditorBindModal.vue?vue&type=script&lang=js"
export * from "./EditorBindModal.vue?vue&type=script&lang=js"

import "./EditorBindModal.vue?vue&type=style&index=0&id=55c78642&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c78642"]])

export default __exports__